import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55b7cd10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-center maxw-280 mx-auto" }
const _hoisted_2 = {
  key: 0,
  class: "blackPanel mb-2"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Pagamento in modalità test", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("b", null, "4242 4242 4242 4242"),
  /*#__PURE__*/_createTextVNode(" pagamento ok")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("b", null, "4000 0025 0000 3155"),
  /*#__PURE__*/_createTextVNode(" pagamento con auth")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("b", null, "4000 0000 0000 9995"),
  /*#__PURE__*/_createTextVNode(" fondi insufficienti")
], -1))
const _hoisted_7 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isTestMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_7))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createVNode(_component_localized_text, {
        class: "fs-4",
        localizedKey: "Completa l'acquisto dalla pagina del nostro processore di pagamento",
        text: "Completa l'acquisto dalla pagina del nostro processore di pagamento"
      })
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary mt-4",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.go && _ctx.go(...args)))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Avanti",
          text: "Avanti"
        })
      ])
    ])
  ]))
}